// src/utils/gps.js
// The phone's position, or null if location is off, refused or slow.
// A position from the last minute is reused so the job suggestions and the
// transaction it leads to see the same spot without asking twice.
export function getPosition({ timeout = 6000 } = {}) {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy }),
      () => resolve(null),
      { timeout, maximumAge: 60000, enableHighAccuracy: true }
    );
  });
}
